'use strict';

const ImportRequestModel = require('process/domain/entity/action/import-request');
const ActionImportAPI = require('balus/infra/api/action/import');


class Repository {
    constructor(project, action) {
        this._project = project;
        this._action = action;
    }

    get(importRequestId) {
        return new Promise((resolve, reject) => {
            (new ActionImportAPI()).get(this._action.key, importRequestId).then((data) => {
                const model = new ImportRequestModel(data);
                resolve(model);
            }, reject);
        });
    }

    preview(importRequestId) {
        return new Promise((resolve, reject) => {
            (new ActionImportAPI()).preview(this._action.key, importRequestId).then((data) => {
                const model = new ImportRequestModel(data);
                resolve(model);
            }, reject);
        });
    }
}

module.exports = Repository;



// WEBPACK FOOTER //
// ./process/domain/repository/action/import.js